import { useContext, useMemo, useState } from 'react';
import { IpaffsContext } from './IpaffsModal';
import IpaffsModaltable from './IpaffsModalTable';
import DataTable from '../../../DataTable';
import { PreferentialTooltip, PreferentialTooltipClick } from '../../ProductInfo/Tooltips';
import { Select } from '../../../Input/Input';
import { QAStoreContext } from '../../QAChecklistTab/QAStore';

const IpaffsModalDetailedView = ({ readOnly }) => {
  const { handleSetItemsSelectedValue, ipaffsCategories, data } = useContext(IpaffsContext);
  const { unifiedLoadData } = useContext(QAStoreContext);

  const [persist, setPersist] = useState({});

  const confirmedCategoryByIpaffsCode = useMemo(() => {
    const items = unifiedLoadData?.[0]?.Items ?? [];
    return items.reduce((acc, item) => {
      if (item?.ipaffsHSCode) {
        acc[item.ipaffsHSCode] = {
          categoryId: item?.categoryId,
          categoryOption: item?.categoryOption,
        };
      }
      return acc;
    }, {});
  }, [unifiedLoadData]);

  return (
    <IpaffsModaltable data={data.data ?? []} persist={persist} setPersist={setPersist}>
      <DataTable.Column colKey="hsCode" key="hsCode" header="HS Code" />
      <DataTable.Column colKey={'origin'} key={'origin'} header="Origin" />
      <DataTable.Column colKey={'description'} key={'description'} header="Description" />
      <DataTable.Column
        colKey="riskCategory"
        header="Risk Category"
        tooltip={
          <PreferentialTooltip>
            <p>This is the list of categories which can apply to this HS Code. This does not include FFNAO.</p>
          </PreferentialTooltip>
        }
      >
        {(item) => {
          return (
            <div className="ipaffs-modal-table-risk-category">
              {item.riskCategory}
              {item?.catDesc && (
                <PreferentialTooltipClick>
                  <p>{item?.catDesc}</p>
                </PreferentialTooltipClick>
              )}
            </div>
          );
        }}
      </DataTable.Column>
      <DataTable.Column
        colKey="confirmedCategory"
        header="Confirmed Category"
        style={{ height: '1px', padding: 0 }}
        tooltip={
          <PreferentialTooltip>
            <p>Select the Risk Category which applies to the HS Code.</p>
          </PreferentialTooltip>
        }
      >
        {(item) => {
          const preConfirmed = confirmedCategoryByIpaffsCode[item?.ipaffsCode];
          const defaultValue = ipaffsCategories?.[item.id]?.value ?? preConfirmed?.categoryId ?? 0;

          return (
            <Select
              hideLabel={true}
              name={`${item.hsCode} category`}
              data={defaultValue}
              options={item?.riskCategoryOptions ?? []}
              required={!readOnly}
              disabled={readOnly}
              stopSetDefault={true}
              setData={(value) => handleSetItemsSelectedValue(item, value)}
            />
          );
        }}
      </DataTable.Column>
      <DataTable.Column colKey={'grossWeight'} key={'grossWeight'} header="Gross Weight (Kg)" />
    </IpaffsModaltable>
  );
};

export default IpaffsModalDetailedView;
